import React from 'react';
import { Building2, FileText, Users, ShieldCheck, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { Button } from '../components/ui/button';

const Business = () => {
  const { t, lang } = useI18n();
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Business</p>
            <h1 className="font-serif text-5xl md:text-6xl mt-4">{t('business.title')}</h1>
            <p className="text-white/70 mt-5">{t('business.subtitle')}</p>
            <Link to="/contact" className="inline-block mt-8">
              <Button className="bg-white hover:bg-white/90 text-black rounded-none h-12 px-8 text-sm tracking-[0.2em] uppercase">
                {lang === 'fr' ? 'Ouvrir un compte' : 'Open an account'} <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
          <div className="aspect-[4/3] overflow-hidden">
            <img src="https://images.unsplash.com/photo-1616804947838-6646ae0e423d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjaGF1ZmZldXJ8ZW58MHx8fHwxNzc4MDY2NzA0fDA&ixlib=rb-4.1.0&q=85" alt="business" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {[
            { icon: Building2, t: lang === 'fr' ? 'Comptes corporate' : 'Corporate accounts', d: lang === 'fr' ? 'Programme dédié pour vos collaborateurs.' : 'Dedicated programme for your teams.' },
            { icon: FileText, t: lang === 'fr' ? 'Facturation centralisée' : 'Centralised billing', d: lang === 'fr' ? 'Une facture mensuelle, des rapports clairs.' : 'One monthly invoice, clear reports.' },
            { icon: Users, t: lang === 'fr' ? 'Roadshows & séminaires' : 'Roadshows & seminars', d: lang === 'fr' ? 'Du minibus à l\u2019autocar 60 places.' : 'From minibus to 60-seat coach.' },
            { icon: ShieldCheck, t: lang === 'fr' ? 'Discrétion & sécurité' : 'Discretion & security', d: lang === 'fr' ? 'Confidentialité totale, chauffeurs formés.' : 'Full confidentiality, trained chauffeurs.' }
          ].map((f, i) => (
            <div key={i}>
              <div className="w-12 h-12 border border-black/15 flex items-center justify-center"><f.icon className="w-5 h-5" /></div>
              <h3 className="font-serif text-2xl mt-6">{f.t}</h3>
              <p className="text-black/60 mt-3 leading-relaxed text-[15px]">{f.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Business;
